import { render, staticRenderFns } from "./CardProductServicePc.vue?vue&type=template&id=06c236c9&scoped=true"
import script from "./CardProductServicePc.vue?vue&type=script&lang=js"
export * from "./CardProductServicePc.vue?vue&type=script&lang=js"
import style0 from "./CardProductServicePc.vue?vue&type=style&index=0&id=06c236c9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c236c9",
  null
  
)

export default component.exports